var App = App || {};

App.Alert = (function ($) {
    "use strict";

    var $header = $("header"),
        $alert = $header.find(".alert-dismissible"),
        $navMobileDropdown = $("section.nav-dropdown.mobile"),
        alertId;

    function init() {
        $alert.on("closed.bs.alert", function () {
            alertId = $(this).attr("id");
            App.Cookies.setItem(alertId, "closed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            setNavMobileDropdownPosition();
        });

        Stickyfill.refreshAll();
    }

    function setNavMobileDropdownPosition() {
        $navMobileDropdown.css("top", Math.round($header.outerHeight()));
        Stickyfill.refreshAll();
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Alert.init();
});